import React, { useState } from 'react';
import { PageTitle } from '@galop/component-library';
import { AppName } from '../Admin/Admin';
import Can from '../Shared/Can';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { UserList } from './UserList';

export const Users = (props) => {
    const config = {
        resourceName: 'user',
        capitalResourceName: 'User',
        pluralResourceName: function () {
            return this.resourceName + 's';
        },
        pluralCapitalResourceName: function () {
            return this.capitalResourceName + 's';
        },
        writeRole: "admin",
        controllerName: 'users'
    };
    const { CurrentUser } = props;
    const [newResource, setNewResource] = useState(false);
    const [resourceIsDirty, setResourceIsDirty] = useState(false);

    return (
        <div className="d-flex flex-column h-100">
            <PageTitle moduleName={config.pluralCapitalResourceName()} flexBehavior="flex-row" AppName={AppName} titleChild={
                <Can role={config.writeRole}
                    yes={() => !newResource && <Button color="light" className="border ms-1 py-0" onClick={() => setNewResource(true)} ><FontAwesomeIcon icon={faPlus} className="text-success" /> New</Button>}
                />}
            />
            <UserList {...{ config }} CurrentUser={CurrentUser} NewResource={newResource} CloseNewResource={() => setNewResource(false)} IsDirty={(isDirty) => setResourceIsDirty(isDirty)} />
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Users/Users.js